import React, { useEffect, useContext, useState } from 'react';
import { LogsProvider, LogsContext } from './ProjectsLogsContext';
import History from '@material-ui/icons/History';
import { NavContext, NavRoutes, UserContext } from '../../../contexts';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-balham.css';

import {
	Paper,
	Avatar,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Typography,
	Button,
	Select,
	MenuItem,
	TextField,
	LinearProgress
} from '@material-ui/core';

import {
	DateTime
} from '../../../common';

// Looking for an icon name?
// look here! https://material-ui.com/components/material-icons/
//import from '@material-ui/icons/'

import { makeStyles } from '@material-ui/core/styles';
import { xor } from 'lodash';
import * as moment from "moment";


let gridApi = null;
let gridColumnApi = null;

const useStyles = makeStyles((theme) => ({
	filterContainer: {
		display: 'flex'
	},
	yearsDescription: {
		fontSize: "1rem",
		alignSelf: 'center'
	},
	yearsSelection: {
		width: "80px",
		marginLeft: "10px",
		textAlign: "center"
	},
	filterProjectsContainer: {
		display: 'flex',
		marginLeft: '80px'
	},
	projectsDescription: {
		fontSize: "1rem",
		alignSelf: 'center'
	},
	searchProject: {
		display: "flex"
	},
	searchButton: {
		alignSelf: 'center',
		fontSize: '12px',
		marginLeft: '30px'
	},
	clearButton: {
		alignSelf: 'center',
		fontSize: '12px',
		marginLeft: '30px'
	},
	root: {
		width: '100%',
		overflow: 'hidden',
		marginTop: '50px'
	},
	author: {
		display: 'flex',
		alignItems: 'center'
	},
	avatar: {
		marginRight: theme.spacing(1)
	},
	table: {

	},
	header: {
		fontSize: '1rem'
	}
}));

const PageContent = (props) => {
	const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
	const classes = useStyles();

	const {
		navigateTo
	} = useContext(NavContext)

	const {
		getBudgetYearsAsync,
		budgetYears
	} = useContext(UserContext);

	const {
		state,
		getProjectsAsync
	} = useContext(LogsContext);

	const {
		isLoadingLogs,
		allProjects
	} = state;

	useEffect(() => {
		addBreadcrumbToken("Logs");
		getBudgetYearsAsync();
	}, [])

	const [selectedYear, setSelectedYear] = useState("");

	useEffect(() => {
		if (budgetYears !== null) {
			if (budgetYears && budgetYears.items && budgetYears.items.length > 0) {
				const years = [];
				budgetYears.items.map(budgetSession => years.push(budgetSession.observedYear));
				years.sort();
				const lastYear = years.pop();
				setSelectedYear(lastYear);
				getProjectsAsync(lastYear);
			}
		}
	}, [budgetYears])

	useEffect(() => {
		if (allProjects !== null) {
			setRowData(
				allProjects.map((x) => {
					const updateDate = new Date(x.updateDate);
					const updateDateUTC = new Date(updateDate.setHours(updateDate.getHours()));
					const updateDateLocal = moment(updateDateUTC).add(- updateDateUTC.getTimezoneOffset(), 'minutes').format("DD/MM/YYYY H:mm:ss");
					
					const deleteDate = new Date(x.deleteDate);
					const deleteDateUTC = new Date(deleteDate.setHours(deleteDate.getHours()));
					const deleteDateLocal = moment(deleteDateUTC).add(- deleteDateUTC.getTimezoneOffset(), 'minutes').format("DD/MM/YYYY H:mm:ss");

					let obj = {};
					obj.projectId = x.projectId;
					obj.author = x.deletedBy ?? x.updatedByFullName;
					obj.date = x.deleteDate ? deleteDateLocal : updateDateLocal;
					obj.action = x.isDeleted ? "Deleted" : x.hasChanges ? "Updated" : "Added";
					obj.project = x.projectId + " - " + x.name;
					obj.changeId = x.lastChangeId;
					return obj;
				})
			);
		}
	}, [allProjects])

	function isFirstColumn(params) {
		const displayedColumns = params.columnApi.getAllDisplayedColumns();
		const thisIsFirstColumn = displayedColumns[0] === params.column;
		return thisIsFirstColumn;
	}

	const [defaultColDef, setDefaultColDef] = useState({
		filter: 'agTextColumnFilter',
		sortable: true,
		editable: false,
		resizable: true,
		headerCheckboxSelection: isFirstColumn,
		checkboxSelection: isFirstColumn
	});

	const [columnDefs, setColumnDefs] = useState(null);

	const [rowData, setRowData] = useState(null);

	useEffect(() => {
		if (rowData !== null)
			if (document.querySelector('.ag-column-select-column:last-child'))
				document.querySelector('.ag-column-select-column:last-child').style.display = "none";

		const allColumns = [
			{
				headerName: 'Author of the change',
				field: 'author',
			},
			{
				headerName: 'Date of the change',
				field: 'date',
				comparator: dateComparator,
				filter: 'agDateColumnFilter',
				filterParams: {
					comparator: (filterLocalDateAtMidnight, cellValue) => {
						const dateParts = cellValue.split(' ')[0].split('/');

						const cellDate = new Date(
							Number(dateParts[2]),
							Number(dateParts[1]) - 1,
							Number(dateParts[0])
						);

						if (filterLocalDateAtMidnight.getTime() === cellDate.getTime())
							return 0;

						if (cellDate < filterLocalDateAtMidnight)
							return -1;

						if (cellDate > filterLocalDateAtMidnight)
							return 1;
					}
				}
			},
			{
				headerName: 'Type of the last change',
				field: "action",
			},
			{
				headerName: 'Project',
				field: 'project',
			},
			{
				headerName: 'Change Id',
				field: 'changeId',
				filter: 'agNumberColumnFilter',
			},
		]

		if (gridApi)
			gridApi.setColumnDefs(allColumns);
	}, [rowData])

	const [sideBar, setSideBar] = useState({
		toolPanels: [
			{
				id: 'columns',
				labelDefault: 'Columns',
				labelKey: 'columns',
				iconKey: 'columns',
				toolPanel: 'agColumnsToolPanel'
			},
			{
				id: 'filters',
				labelDefault: 'Filters',
				labelKey: 'filters',
				iconKey: 'filter',
				toolPanel: 'agFiltersToolPanel'
			}
		],
		position: 'left'
	});

	function dateComparator(date1, date2) {
		const date1Number = dateConverter(date1);
		const date2Number = dateConverter(date2);

		if (date1Number === null && date2Number === null)
			return 0;

		if (date1Number === null)
			return -1;

		if (date2Number === null)
			return 1;

		return date1Number - date2Number;
	}

	function dateConverter(date) {
		if (date === undefined || date === null)
			return null;

		const year = date.split(" ")[0].split("/")[2];
		const month = date.split(" ")[0].split("/")[1];
		const day = date.split(" ")[0].split("/")[0];
		const hours = date.split(" ")[1].split(":")[0];
		const minutes = date.split(" ")[1].split(":")[1];
		const seconds = date.split(" ")[1].split(":")[2];

		return new Date(year, month, day, hours, minutes, seconds);
	}

	const [selectedLogs, setSelectedLogs] = useState(null);
	function onSelectionChanged() {
		const selectedLogs = gridApi.getSelectedRows();
		setSelectedLogs(selectedLogs);
	};

	useEffect(() => {
		if (gridApi) {
			if (isLoadingLogs)
				gridApi.showLoadingOverlay();
			else
				gridApi.showNoRowsOverlay();
		}
	}, [isLoadingLogs])

	return (
		<div>

			<>
				<div className={classes.filterContainer}>
					<div className={classes.filterContainer}>
						<label className={classes.yearsDescription} value="Select year: ">
							Filter by year:
						</label>
						<Select
							className={classes.yearsSelection}
							value={selectedYear}
							onChange={x => {
								setSelectedYear(x.target.value);
								getProjectsAsync(x.target.value);
							}}
						>
							{budgetYears &&
								budgetYears.items &&
								budgetYears.items.length > 0 &&
								budgetYears.items.map((year, index) => {
									return (
										<MenuItem key={index} value={year.observedYear}>
											{year.observedYear}
										</MenuItem>
									);
								})}
						</Select>
					</div>
					<div>
						<Button
							color="primary"
							size="small"
							variant="contained"
							style={{ marginRight: '15px', marginLeft: '15px', marginTop: '5px', fontSize: '11px' }}
							disabled={selectedLogs && selectedLogs.length === 1 ? false : true}
							onClick={async () => {
								navigateTo(NavRoutes.Admin.ViewLog, [selectedLogs[0].projectId]);
							}
							}
						>View Logs</Button>
					</div>
				</div>
			</>
			<br />
			<div className="ag-theme-balham" style={{ height: 'calc(90vh - 90px)', overflowX: 'auto' }}>
				<AgGridReact
					defaultColDef={defaultColDef}
					columnDefs={columnDefs}
					rowData={rowData}
					animateRows={true}
					suppressRowClickSelection={true}
					enableRangeSelection={true}
					enableFillHandle={true}
					sideBar={sideBar}
					onGridReady={params => {
						gridApi = params.api;
						gridColumnApi = params.columnApi;
					}}
					suppressColumnVirtualisation={true}
					multiSortKey={'ctrl'}
					rowSelection="single"
					onSelectionChanged={onSelectionChanged}
				/>
			</div>
		</div>
	);
}

export const LogsPage = () => {
	return (
		<LogsProvider>
			<PageContent />
		</LogsProvider>
	);
}